import tw from "tailwind-styled-components";
import styled from "styled-components";
import { ChevronDownOutline } from "@carbon/icons-react";

export const PathologiesWrapperMobile = tw.div`
  flex
  flex-col
  gap-2
  over
`;

export const MobileHeader = tw.div`
  flex
  flex-col
  gap-5
  px-6
`;

export const Title = tw.h3`
  text-lg
  font-bold
`;

export const Description = tw.p`
  text-base
`;

export const ButtonWrapper = tw.div`
  flex
  flex-col
  items-center
`;

export const PathologiesItemsWrapper = tw.div`
  flex
  flex-row
  gap-3
  overflow-x-auto

  desktop:overflow-hidden
`;


export const ArrowsWrapper = tw.div`
  hidden
  gap-2
  items-center
  justify-end
  desktop:flex
`

export const ArrowRight = styled(ChevronDownOutline)`
  transform: rotate(-90deg);
  ${({ disabled }) =>
    disabled ? "color:var(--gray200);" : "color:var(--primary800);"}
`

export const ArrowLeft = styled(ChevronDownOutline)`
  transform: rotate(90deg);
  ${({ disabled }) =>
    disabled ? "color:var(--gray200);" : "color:var(--primary800);"}
`